import { BrowserModule }              from '@angular/platform-browser';
import { BrowserAnimationsModule }    from '@angular/platform-browser/animations';
import { FormsModule }                from '@angular/forms';
import { HttpModule }                 from '@angular/http';
import { NgModule }                   from '@angular/core';
import { NguiAutoCompleteModule }     from '@ngui/auto-complete';
import { OAuthModule }                from 'angular-oauth2-oidc';
import { SimpleNotificationsModule }  from 'angular2-notifications';

import { AppComponent }         from './app.component';
import { AppRoutingModule }     from './app-routing.module';

import { AuthGuard }                                            from './guards';
import { CtlService , UserService }                             from './services';
import { ExportComponent, HomeComponent, NavigationComponent }  from './components';

@NgModule({
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    NguiAutoCompleteModule,
    OAuthModule.forRoot(),
    SimpleNotificationsModule.forRoot()
  ],
  declarations: [
    AppComponent,
    ExportComponent,
    HomeComponent,
    NavigationComponent
  ],
  providers: [ AuthGuard, CtlService, UserService ],
  bootstrap: [ AppComponent ]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts